import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core"; import { Location } from "@angular/common";

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ReponseBase } from './reponse-base';
import { ContactEntite } from '../entites/contact';

@Injectable({ providedIn: 'root' })
export class ContactService {

  private obtenirListeUrl = environment.apiBaseUrl + 'contact';
  private obtenirListeCourrielsUrl = environment.apiBaseUrl + 'contact/courriels';
  private obtenirListeParFournisseurUrl = environment.apiBaseUrl + 'contact/fournisseur/{id}';
  private obtenirUrl = environment.apiBaseUrl + 'contact/{id}';
  private ajouterUrl = environment.apiBaseUrl + 'contact';
  private modifierUrl = environment.apiBaseUrl + 'contact/modifier';
  private supprimerUrl = environment.apiBaseUrl + 'contact/{id}';


  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    private http: HttpClient,
    public router: Router) { }

  public ObtenirListe(): Promise<ReponseBase<ContactEntite[]>> {
    var p = this.http.get<ReponseBase<ContactEntite[]>>(this.obtenirListeUrl)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public ObtenirListecouriels(): Promise<ReponseBase<string[]>> {
    var p = this.http.get<ReponseBase<string[]>>(this.obtenirListeCourrielsUrl)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public ObtenirListeParFournisseur(id: number): Promise<ReponseBase<ContactEntite[]>> {
    var p = this.http.get<ReponseBase<ContactEntite[]>>(this.obtenirListeParFournisseurUrl.replace('{id}', id.toString()))
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Obtenir(id: number): Promise<ReponseBase<ContactEntite>> {
    var p = this.http.get<ReponseBase<ContactEntite>>(this.obtenirUrl.replace('{id}', id.toString()))
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Ajouter(contact: ContactEntite): Promise<ReponseBase<ContactEntite>> {
    var p = this.http.post<ReponseBase<ContactEntite>>(this.ajouterUrl, JSON.stringify(contact), this.httpOptions)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Modifier(contact: ContactEntite): Promise<ReponseBase<ContactEntite>> {
    var p = this.http.post<ReponseBase<ContactEntite>>(this.modifierUrl, JSON.stringify(contact), this.httpOptions)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Supprimer(id: number): Promise<ReponseBase<number>> {
    var p = this.http.delete<ReponseBase<number>>(this.supprimerUrl.replace('{id}', id.toString()))
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);

      this.log(`${operation} failed: ${error.message}`);

      this.router.navigateByUrl('erreurtechnique');

      return of(result as T);
    };
  }

  private log(message: string) {
    console.log(message);
  }
}
